export var GeneralServices = /*#__PURE__*/ function(GeneralServices) {
    GeneralServices[GeneralServices["FriendService"] = 0] = "FriendService";
    GeneralServices[GeneralServices["NotificationService"] = 1] = "NotificationService";
    return GeneralServices;
}({});
// number associated with status is priority, e.g. InGame > OnlineAndIdle; see OnlineFriendManager.getOnlineStatusFromUser
export var OnlineStatus = /*#__PURE__*/ function(OnlineStatus) {
    OnlineStatus[OnlineStatus["Offline"] = 0] = "Offline";
    OnlineStatus[OnlineStatus["OnlineAndIdle"] = 1] = "OnlineAndIdle";
    OnlineStatus[OnlineStatus["InRoom"] = 2] = "InRoom";
    OnlineStatus[OnlineStatus["InGame"] = 3] = "InGame";
    return OnlineStatus;
}({});
export var GeneralAction = /*#__PURE__*/ function(GeneralAction) {
    GeneralAction[GeneralAction["RegisterToFriendService"] = 1] = "RegisterToFriendService";
    GeneralAction[GeneralAction["ChangeOnlineStatus"] = 2] = "ChangeOnlineStatus";
    GeneralAction[GeneralAction["GetAllFriendsOnlineStatus"] = 3] = "GetAllFriendsOnlineStatus";
    GeneralAction[GeneralAction["InviteFriendToRoom"] = 4] = "InviteFriendToRoom";
    GeneralAction[GeneralAction["GetAllRoomInvitesReceived"] = 5] = "GetAllRoomInvitesReceived";
    GeneralAction[GeneralAction["RespondToFriendRoomInvite"] = 6] = "RespondToFriendRoomInvite";
    GeneralAction[GeneralAction["GetNotifications"] = 7] = "GetNotifications";
    GeneralAction[GeneralAction["MarkNotificationAsRead"] = 8] = "MarkNotificationAsRead";
    GeneralAction[GeneralAction["MarkAllNotificationsAsRead"] = 9] = "MarkAllNotificationsAsRead";
    GeneralAction[GeneralAction["RegisterToNotificationService"] = 10] = "RegisterToNotificationService";
    return GeneralAction;
}({});
